import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import {
  CREATE_EXPENSE,
  UPDATE_EXPENSE,
} from "../../../Schema/Expense";

const useExpenseForm = ({ handleClose, resetForm, setRefetch }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createExpense] = useMutation(CREATE_EXPENSE, {
    onCompleted: ({ createExpense }) => {
      setLoading(false);

      if (createExpense?.isSuccess === true) {
        setAlert(true, "success", createExpense?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createExpense?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateExpense] = useMutation(UPDATE_EXPENSE, {
    onCompleted: ({ updateExpense }) => {
      setLoading(false);
      if (updateExpense?.isSuccess === true) {
        setAlert(true, "success", updateExpense?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateExpense?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  return { updateExpense, createExpense, loading, setLoading };
};

export default useExpenseForm;
